<template>
    <div>
        <b-card>
            <template slot="header">
                <h4 class="mt-2 custom-card-header-text">Response Type <img src="img/tooltip.png" v-b-tooltip.hover.bottom title="How your advisors help by type of response (30-day average)." alt="tooltip" height="12"/></h4>
                <ul class="list-inline float-right">
                    <li class="list-inline-item" aria-hidden="true">
                        <button type="button" aria-label="Export" aria-live="assertive" @click="exportData()" class="btn custom-card-header-filter btn-dropbox tab-focus"><i class="icon-cloud-download"></i></button>
                    </li>
                </ul>
            </template>
            <b-card-body>
                <v-client-table v-bind:data="responseType" v-bind:columns="columns" :options="options" id="dataTable" class="response-type">
                </v-client-table>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import { exportCSV } from '@/assets/js/common';

export default {
    name: 'request-engagement',
    data() {
        return {
            responseType: [],
            columns: ['date', 'advice', 'call', 'meeting'],
            token: localStorage.getItem('token'),
            options: {
                sortable: ['date', 'advice', 'call', 'meeting'],
                sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
                pagination: {
                    chunk: 5,
                    edge: false,
                    nav: 'scroll'
                }
            }
        }
    },
    created() {
        this.loadData();
    },
    methods: {
        loadData() {
            let url = `${process.env.VUE_APP_API_BASE_URL}/dashboard/response_type_by_date`;
            if (this.$route.query.community_id) {
                url = `${process.env.VUE_APP_API_BASE_URL}/dashboard/response_type_by_date/?community_id=${this.$route.query.community_id}`
            }
            this.axios.get(url, {headers: {'x-access-token': this.token}}).then(async response => {
                if (response.data.length) {
                    this.responseType = response.data;
                }
            }).catch(err => {
                if (err.response.status  === 401) {
                    localStorage.removeItem('authUser');
                    this.$router.push('/login');
                }
            });
			this.$helpers.setTabindexOnTableCells();
        },
        exportData: async function() {
            if (this.responseType.length) {
                await exportCSV(this.responseType.slice(), 'response_type', [], ['date']);
            }
        }
    }
}
</script>
